import React from "react";
import { UxIcon, UxIconEnum, UxSizeEnum } from "@imaginelearning/mps-ux-component-library";
import { ISubAssessment } from "../types";
import { SubjectIcon } from "../svg-images/subjects/subject-icon";

interface IFormativeInProgressProps {
  assessment: ISubAssessment;
  onStart: Function;
}

function FormativeInProgress(props: IFormativeInProgressProps) {
  const start = () => {
    if (props.onStart) {
      props.onStart(props.assessment);
    }
  };
  return (
    <div className="formative-bubble inprogress">
      <div className="inner-bubble">
        <div className="mpng-ux-visual-action-content align-items-center flex-column justify-content-center text-center text-white d-flex h-100 m-0">
          <div className="visual-action-image mb-4">
            <SubjectIcon subject={props.assessment.subject ?? "Math"} />
          </div>
          <div className="mb-3">
            <h2
              className="card-title visual-action-title m-0 truncate-lines text-lg card-title"
              title="Understanding Place Value"
            >
              {props.assessment.name}
            </h2>
          </div>
          <button
            type="button"
            aria-label="Go"
            tabIndex={0}
            className="mpng-ux-action shape rounded-pill shadow-sm mt-3 start-btn px-5 mx-auto text-white stretched-link after-border-radius-circle btn btn-success btn-lg"
            onClick={start}
          >
            <div className="mpng-ux-enhanced-icon d-flex align-items-center">
              <div className="enhanced-icon-text">
                <span className="me-1">GO</span>
              </div>
              <div className="enhanced-icon-icon">
                <UxIcon icon={UxIconEnum.ARROW_RIGHT} size={UxSizeEnum.MEDIUM} className="arrow-right" />
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default FormativeInProgress;
